export default __webpack_public_path__ + "static/media/1349.c2d55bf3.png";